export const UPLOAD_FILE_START = 'UPLOAD_FILE_START'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL'

export const UPLOAD_ATTACHMENT_START = 'UPLOAD_ATTACHMENT_START'
export const UPLOAD_ATTACHMENT_FAIL = 'UPLOAD_ATTACHMENT_FAIL'

export const DOWNLOAD_ATTACHMENT_START = 'DOWNLOAD_ATTACHMENT_START'
export const DOWNLOAD_ATTACHMENT_FAIL = 'DOWNLOAD_ATTACHMENT_FAIL'

export const DOWNLOAD_SECTIONS_START = 'DOWNLOAD_SECTIONS_START'
export const DOWNLOAD_SECTIONS_FAIL = 'DOWNLOAD_SECTIONS_FAIL'

export const IMPORT_CSV_START = 'IMPORT_CSV_START'
export const IMPORT_CSV_FAIL = 'IMPORT_CSV_FAIL'

export const SAVE_SECTIONS_START = 'SAVE_SECTIONS_START'
export const SAVE_SECTIONS_FAIL = 'SAVE_SECTIONS_FAIL'

export const CHECK_VALIDITY_START = 'CHECK_VALIDITY_START'
export const CHECK_VALIDITY_FAIL = 'CHECK_VALIDITY_FAIL'

export const DOWNLOAD_FILE_START = 'DOWNLOAD_FILE_START'
export const DOWNLOAD_FILE_FAIL = 'DOWNLOAD_FILE_FAIL'

export const LOAD_FILE_FAIL = 'LOAD_FILE_FAIL'

export const FETCH_STATE = 'FETCH_STATE'
export const FETCH_SECTIONS = 'FETCH_SECTIONS'
export const REPLACE_SECTION = 'REPLACE_SECTION'
export const SET_SECTION_DATA = 'SET_SECTION_DATA'
export const SET_SECTION_DATA_ARRAY = 'SET_SECTION_DATA_ARRAY'
export const SET_SECTION_DATA_CUSTOM_ARRAY = 'SET_SECTION_DATA_CUSTOM_ARRAY'
export const SET_POZYCJE_UZ_SKONS = 'SET_POZYCJE_UZ_SKONS'
export const SET_POZYCJE_UZ_SKONS_V12 = 'SET_POZYCJE_UZ_SKONS_V12'
export const SET_NAME = 'SET_NAME'
export const SET_DATES = 'SET_DATES'
export const SET_VALIDITY_ERRORS = 'SET_VALIDITY_ERRORS'
export const SET_ACTUAL_VALIDITY_ERROR = 'SET_ACTUAL_VALIDITY_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_CZY_KRS = 'SET_CZY_KRS'
export const SET_CZY_WYLACZONE_FORMULY_ZZWK = 'SET_CZY_WYLACZONE_FORMULY_ZZWK'

export const ADD_DETAIL = 'ADD_DETAIL'
export const DELETE_DETAIL = 'DELETE_DETAIL'

export const SET_CITRZIS_DATA_ARRAY = 'SET_CITRZIS_DATA_ARRAY'
export const GET_LICENCE_FAIL = 'GET_LICENCE_FAIL'
export const GET_LICENCE_SUCCESS = 'GET_LICENCE_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const SET_ZAKUP_LICENCJI = 'SET_ZAKUP_LICENCJI'
export const GET_STRUCTURES = 'GET_STRUCTURES'
export const CLEAR_TABLE = 'CLEAR_TABLE'
export const SET_STRUCTURE = 'SET_STRUCTURE'
export const SET_GUS_LOADING = 'SET_GUS_LOADING'
export const SET_CZY_PODSUMOWANIE = 'SET_CZY_PODSUMOWANIE'
export const SET_CZY_TRWA_SPRAWDZANIE = 'SET_CZY_TRWA_SPRAWDZANIE'
export const SET_CZY_TRWA_IMPORT = 'SET_CZY_TRWA_IMPORT'
export const SET_CZY_WYBOR_DATY = 'SET_CZY_WYBOR_DATY'
export const SET_DATA_SPORZADZENIA = 'SET_DATA_SPORZADZENIA'
export const SET_PACZKA_ZIP = 'SET_PACZKA_ZIP'
